module.exports = __webpack_public_path__ + "static/media/skype.1577db6f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/contacts/skype.svg
// module id = 365
// module chunks = 0